import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: "app-assessment",
    templateUrl: "./assessment.component.html",
    styleUrls: ["./assessment.component.scss"],
    standalone: false
})
export class AssessmentComponent implements OnInit {
  @Output() back = new EventEmitter<void>();
  @Output() assesementComplete = new EventEmitter<void>();

  @Input() scheduleId!: any;
  @Input() uploadInstructions!:any;
  @Input() evidenceRequired!:any;
  @Input() isOverdue!:any;

  assessmentForm: FormGroup;
  attachedFiles: File[] = [];
  backgroundColorButton = "";
  isSubmiited: boolean =false;
   uploadCompleted = false;
   uploadError = false;
   uploadSuccess = false;
   showErrorDetails = false;
    detailedErrorMessage = '';
    autoDoneTimeout: any;


  constructor(
    private fb: FormBuilder,
    private localStorage: LocalStorageSettingsService,
    private jsignalsService: JsignalService,
    private snackBar: MatSnackBar
  ) {
    this.assessmentForm = this.fb.group({
      signalDetected: [false, Validators.required],
      assessmentNotes: ["", Validators.required],
      delayReason: [""],
      attachments: [null] // initially not required
    });
  }

  ngOnInit(): void {
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    console.log("schedule id inside attachement component", this.scheduleId);
    console.log("Upload Instruction",this.uploadInstructions);
    console.log("Evidencerequired",this.evidenceRequired);
    console.log("isOverdue",this.isOverdue);

    this.isFieldMandatory("attachments",this.evidenceRequired?.toLowerCase() === "yes");
    this.isFieldMandatory("delayReason",this.isOverdue  == true);
  }

onFileSelected(event: any) {
  const files: FileList = event.target.files;

  // Merge newly selected files with existing list
  const newFiles = Array.from(files);
  this.attachedFiles = [...this.attachedFiles, ...newFiles];

  // Update form control value
  this.assessmentForm.get("attachments")?.setValue(this.attachedFiles);
  this.assessmentForm.get("attachments")?.updateValueAndValidity();

  // Reset input so selecting same file again works
  event.target.value = '';
}


  removeFile(file: File) {
    this.attachedFiles = this.attachedFiles.filter((f) => f !== file);
      this.assessmentForm.get("attachments")?.setValue(this.attachedFiles.length > 0 ? this.attachedFiles : null);
      this.assessmentForm.get("attachments")?.updateValueAndValidity();
  }

onSubmit(event: Event): void {
  event.preventDefault();

  this.assessmentForm.markAllAsTouched();

  if (this.assessmentForm.invalid) {
    console.log("Form invalid, cannot submit");
    return;
  }

  this.isSubmiited = true;
  this.uploadCompleted = false; // Reset state before upload
  this.uploadError = false
  this.uploadSuccess = false 

    //convert BEFORE sending to backend
  const formValue = { ...this.assessmentForm.value };
  formValue.signalDetected = formValue.signalDetected ? "yes" : "no";

  const formData = new FormData();
  const assessmentBlob = new Blob(
    [JSON.stringify(formValue)],
    { type: "application/json" }
  );

  formData.append("assessment", assessmentBlob);

  if (this.attachedFiles?.length > 0) {
    this.attachedFiles.forEach(file => {
      formData.append("attachments", file, file.name);
    });
  }

  console.log("Payload ready:", formData);

this.jsignalsService.completeReviewActivity(this.scheduleId, formData)
  .subscribe((res: any) => {
    if (res.error === true) {
      // error 
      console.error("Error:", res);
      // Store the raw error for "Show more" section
      this.detailedErrorMessage = res.statusMessage ;
      setTimeout(() => {
      this.uploadCompleted = true;
      this.uploadSuccess = false  
      this.uploadError = true;
    }, 5000);
      return;
    }

    //  success (next) logic
    console.log("Response:", res);
    console.log("upload Completed in response 1", this.uploadCompleted);

    setTimeout(() => {
      this.uploadCompleted = true;
      this.uploadSuccess = true;
      this.uploadError = false;
      // Start auto-done timer
       this.startAutoDoneTimer();
    }, 5000);

    console.log("upload Completed in response 2", this.uploadCompleted);
  });
}


  goBack() {
    this.back.emit();
  }

  toggleErrorDetails() {
  this.showErrorDetails = !this.showErrorDetails;
}

onAssesementDone(){
  
    if (this.autoDoneTimeout) {
    clearTimeout(this.autoDoneTimeout);
  }
  this.assesementComplete.emit();
}

private isFieldMandatory(controlName: string, condition: boolean) {
  const control = this.assessmentForm.get(controlName);

  if (!control) return;

  if (condition) {
    control.setValidators(Validators.required);
  } else {
    control.clearValidators();
  }

  control.updateValueAndValidity();
}

startAutoDoneTimer() {
  if (this.autoDoneTimeout) {
    clearTimeout(this.autoDoneTimeout);
  }

  // Auto-click Done after 5 seconds
  this.autoDoneTimeout = setTimeout(() => {
    this.onAssesementDone();
  }, 5000);
}


}
